module.exports = __webpack_public_path__ + "static/media/arrow.4b9c5527.svg";